import axios from 'axios'
// import {MessageBox, Message} from 'element-ui'
import Router from '../router/router'
import { Notification } from 'element-ui';
import Cookie from "js-cookie";
const service = axios.create({
    headers: {
        "X-Request-Channel": "UM",
        "X-Request-Origin": "HT"
    },
    timeout: 60000 // request timeout
})

service.interceptors.request.use(
    config => {
        if (Cookie.get('AuthToken')) {
            config.headers["AuthToken"] = Cookie.get('AuthToken')
        }
        let date = Date.parse(new Date()) || 0;
        config.headers["X-USER-AGENT"] = `HT|1.5.1|PC|PC||${date}||false||`
        return config
    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data

        // if the custom code is not 20000, it is judged as an error.
        if (res.code != 1 && res.code !== 200 && res.code !== 20000) {

            // Message({
            //     message: res.msg || 'Error',
            //     type: 'error',
            //     duration: 5 * 1000
            // })
            Notification.closeAll()
            Notification({
                message: res.msg || 'Error',
                type:'error',
                duration: 5 * 1000
            })

            if (res.code === 116002002) {
                Cookie.remove('AuthToken')
                Router.push(`/`)
            }
            // return Promise.reject(new Error(res.msg || 'Error'))
            return response
        } else {
            return response
        }
    },
    error => {
        console.log('err' + error) // for debug
        // Message({
        //     message: error.message,
        //     type: 'error',
        //     duration: 5 * 1000
        // })
        // Notification.closeAll()
        Notification({
            message:error.message,
            type:'error',
            duration: 5 * 1000
        })
        return error
    }
)
export default service